module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.eot";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.eot
// module id = 179
// module chunks = 319 323